import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type IconSize = 'small' | 'medium' | 'large' | 'very-large';
export type LoadingPosition = 'right' | 'bottom';
export type FontSize = 'small' | 'normal';
export type Color = 'primary' | 'secondary';

@Component({
  selector: 'grid-ui-loading',
  host: {
    'data-hook': 'loading-spinner',
  },
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoadingComponent {
  @Input() public message = 'Loading, please wait.';
  @Input() public messagePosition: LoadingPosition = 'bottom';
  @Input() public size: IconSize = 'small';
  @Input() public fontSize: FontSize = 'normal';
  @Input() public color: Color = 'primary';
}
